export const RoleEnum = new Map<number, 
{ label: string; }>([
  [1, { label: "Admin"}],
  [2, { label: "Partner"}],
  [3, { label: "Employee"}],
  [4, { label: "User"}],
]);